import { Component, Input, OnInit } from '@angular/core';
import packageDetails from  "../mockdata/packageDetails.json";

@Component({
  selector: 'cmpts-package-details-form',
  templateUrl: './package-details-form.component.html',
  styleUrls: ['./package-details-form.component.css']
})
export class PackageDetailsFormComponent implements OnInit {
  packageDts = packageDetails;
  breakpoint: number;
  @Input() data:any={};
  constructor() { }

  ngOnInit() {
    
  }
    
}